const generateEnumerabilityPreventingEntropy = (length = 5) => {
  return (Math.random() * Math.pow(10, length)).toFixed(0).padStart(length, "0");
};
export {
  generateEnumerabilityPreventingEntropy
};
//# sourceMappingURL=generateEnumerabilityPreventingEntropy.js.map
